import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from "@sentry/react";

import App from './App';

Sentry.init({
  dsn: "https://a69dc039683a2e6686bfa25d51cd84a1@o4510373668192256.ingest.us.sentry.io/4510373670748160",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true
});

ReactDOM.createRoot(document.getElementById('root')).render(<App />)
